// extracted by mini-css-extract-plugin
module.exports = {"formWrapper":"EntriesForm_formWrapper__7DccG","loginForm":"EntriesForm_loginForm__14t6E"};